import api from './api';

export const searchSimilar = async (file, filters = {}, weights = {}, operationIds = []) => {
  const formData = new FormData();
  formData.append('file', file);

  // Filtros básicos
  if (filters.part_type) {
    formData.append('part_type', filters.part_type);
  }
  if (filters.has_tallado !== undefined && filters.has_tallado !== null) {
    formData.append('has_tallado', filters.has_tallado);
  }
  if (filters.has_rectificado !== undefined && filters.has_rectificado !== null) {
    formData.append('has_rectificado', filters.has_rectificado);
  }
  if (filters.has_chavetero !== undefined && filters.has_chavetero !== null) {
    formData.append('has_chavetero', filters.has_chavetero);
  }

  const limitValue = filters.limit || 10;
  formData.append('limit', limitValue);

  // Operaciones (para compatibilidad futura)
  if (operationIds.length > 0) {
    formData.append('operation_ids', JSON.stringify(operationIds));
  }

  // Filtros de parámetros de operación (formato: param_key_min, param_key_max)
  // Extraer todos los filtros que tengan _min o _max
  const operationFilters = {};
  Object.entries(filters).forEach(([key, value]) => {
    if ((key.endsWith('_min') || key.endsWith('_max')) && value !== null && value !== undefined && value !== '') {
      operationFilters[key] = value;
    }
  });
  if (Object.keys(operationFilters).length > 0) {
    formData.append('operation_filters', JSON.stringify(operationFilters));
  }

  // Pesos de similitud (formato actual del backend)
  formData.append('weight_part_type', weights.part_type || 30);
  formData.append('weight_diameter_range', weights.diameter_range || 15);
  formData.append('weight_has_tallado', weights.has_tallado || 15);
  formData.append('weight_modulo', weights.modulo || 10);
  formData.append('weight_has_rectificado', weights.has_rectificado || 10);
  formData.append('weight_has_chavetero', weights.has_chavetero || 10);
  formData.append('weight_num_taladros', weights.num_taladros || 10);

  const response = await api.post('/analyses/search-similar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const getAnalysisImage = async (hash) => {
  const response = await api.get(`/analyses/${hash}/image`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
};

export const getSimilaritySearchResults = async (searchHash) => {
  const response = await api.get(`/analyses/search-similar/${searchHash}`);
  return response.data;
};

export const startHeuristicSearch = async (analysisHash, options = {}) => {
  const body = {
    existing_hashes: options.existingHashes || [],
    limit: options.limit || 30,
  };
  if (options.pageNumber !== undefined && options.pageNumber !== null) {
    body.page_number = options.pageNumber;
  }

  const startResponse = await api.post(`/analyses/${analysisHash}/similars/heuristic`, body);
  const { job_id } = startResponse.data;

  return new Promise((resolve, reject) => {
    const poll = setInterval(async () => {
      try {
        const result = await api.get(`/analyses/${analysisHash}/similars/heuristic/${job_id}`);
        if (result.data.status === 'validating') {
          if (options.onValidating) options.onValidating();
        } else if (result.data.status !== 'calculating') {
          clearInterval(poll);
          resolve(result.data);
        }
      } catch (err) {
        clearInterval(poll);
        reject(err);
      }
    }, 3000);
  });
};

export const checkDuplicate = async (file, options = {}) => {
  const formData = new FormData();
  if (options.reuseFileFromHash) {
    formData.append('reuse_file_from_hash', options.reuseFileFromHash);
  } else if (file instanceof File || file instanceof Blob) {
    formData.append('file', file);
  }
  // Si no hay ninguno de los dos, no añadimos 'file' (evita string "null" en multipart)
  // y dejamos que el backend devuelva su 400 "Se requiere file o reuse_file_from_hash"

  if (options.existingHash) formData.append('existing_hash', options.existingHash);
  if (options.existingPage !== undefined && options.existingPage !== null) formData.append('existing_page', options.existingPage);
  if (options.excludeHash) formData.append('exclude_hash', options.excludeHash);
  if (options.stage) formData.append('stage', options.stage);
  if (options.destinationFolder) formData.append('destination_folder', options.destinationFolder);
  if (options.alreadySearchedHashes) formData.append('already_searched_hashes', JSON.stringify(options.alreadySearchedHashes));
  if (options.existingAboveCount !== undefined) formData.append('existing_above_count', options.existingAboveCount);
  if (options.existingBelowThreshold) formData.append('existing_below_threshold', JSON.stringify(options.existingBelowThreshold));

  const startResponse = await api.post('/analyses/check-duplicate', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  const { job_id } = startResponse.data;

  return new Promise((resolve, reject) => {
    const poll = setInterval(async () => {
      try {
        const result = await api.get(`/analyses/check-duplicate/result/${job_id}`);
        if (result.data.status === 'validating') {
          if (options.onValidating) options.onValidating();
        } else if (result.data.status !== 'calculating') {
          clearInterval(poll);
          resolve(result.data);
        }
      } catch (err) {
        clearInterval(poll);
        reject(err);
      }
    }, 3000);
  });
};
